function getPayload({ user, card, formValues }) {
    const denomination = parseInt(formValues.denomination);
    const quantity = parseInt(formValues.quantity);
    const payload = {
        sku: card.sku,
        price: denomination,
        qty: quantity,
        comment: formValues.comment,
        MasterGiftCard: card.MasterGiftCard
    };

    return payload;
}

export default getPayload;
